export default {
  massRemove: 'Supprimer les règles de résolution',
  massEnable: 'Activer les règles de résolution',
  massDisable: 'Désactiver les règles de résolution',
  removeForbidden: '{name} cannot be deleted.',
  disableForbidden: '{name} cannot be disabled.',
};
